import { memo, useEffect, useState } from "react";
import { useStiggContext } from "@stigg/react-sdk";
import style from "./style/SvixWrapper.module.scss";
import SvixEmbed from "./svixEmbed";

const MemoizedSvixEmbed = memo(SvixEmbed);

export default function SvixWrapper() {
  const { stigg } = useStiggContext();
  const { hasAccess } = stigg.getBooleanEntitlement({ featureId: "feature-webhooks" });
  const [featureAllowed, setFeatureAllowed] = useState(false);

  useEffect(() => {
    setFeatureAllowed(hasAccess);
  }, [hasAccess]);

  if (!featureAllowed) {
    return null;
  }

  return (
    <div className={style.svixWrapper}>
      <div className={style.header}>
        <div>
          <h3>Webhooks</h3>
          <small>Configure application endpoints, send test events, and view logs.</small>
        </div>
      </div>
      <MemoizedSvixEmbed />
    </div>
  );
}
